import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/** Monté une fois dans index.js. Ouvre sur l'event `pfm:open-office`
 *  (detail : { url, filename, telecharger? }) : aperçu des formats Office
 *  (.doc, .xls, .ppt…) par la visionneuse en ligne de Microsoft. `url` est
 *  une URL publique temporaire (SAS) que Microsoft va lire. */
const GlobalOfficeViewer = () => {
  const { t } = useTranslation();
  const [courant, setCourant] = useState(null);
  const [charge, setCharge] = useState(false);
  const [telechargement, setTelechargement] = useState(false);

  useEffect(() => {
    const onOpen = (e) => {
      const { url, filename, telecharger } = e.detail || {};
      if (typeof url !== 'string') return;
      setCharge(false);
      setCourant({ url, filename: filename || 'document', telecharger });
    };
    window.addEventListener('pfm:open-office', onOpen);
    return () => window.removeEventListener('pfm:open-office', onOpen);
  }, []);

  if (!courant) return null;

  const fermer = () => setCourant(null);
  const telecharger = async () => {
    setTelechargement(true);
    try { await courant.telecharger(); } finally { setTelechargement(false); }
  };

  const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 1000010, display: 'flex', flexDirection: 'column' };
  const header = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.6rem 1rem', background: '#1f2937', color: 'white', flex: '0 0 auto' };
  const body = { flex: '1 1 auto', position: 'relative', background: '#374151' };
  const btn = { background: 'none', border: '1px solid rgba(255,255,255,0.5)', color: 'white', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: '0.85rem' };

  return (
    <div style={overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) fermer(); }}>
      <div style={header}>
        <span style={{ fontSize: '0.9rem', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📄 {courant.filename}</span>
        <div style={{ display: 'flex', gap: 8 }}>
          {courant.telecharger && (
            <button style={{ ...btn, opacity: telechargement ? 0.6 : 1 }} onClick={telecharger} disabled={telechargement}>
              ⬇︎ {telechargement ? t('visionneuseDocument.telechargementEnCours') : t('visionneuseDocument.telechargerOriginal')}
            </button>
          )}
          <button style={btn} onClick={fermer}>✕ {t('visionneuseDocument.fermer')}</button>
        </div>
      </div>
      <div style={body}>
        {!charge && (
          <p style={{ color: 'white', textAlign: 'center', position: 'absolute', top: 24, left: 0, right: 0 }}>
            {t('visionneuseDocument.chargementApercu')}
          </p>
        )}
        <iframe
          title={courant.filename}
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(courant.url)}`}
          onLoad={() => setCharge(true)}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0, background: 'white' }}
        />
      </div>
    </div>
  );
};

export default GlobalOfficeViewer;
